import { isToolUIPart } from 'ai';
import { useIntl } from 'react-intl';
import { Stack } from '@rossum/ui/material';
import type { ChatUIMessage } from '../hooks/UseAgentChat/schemas';
import { CollapsibleSection } from './CollapsibleSection';
import { getSubagentRuns, getSubagentToolCalls } from './subagentRuns';
import { extractToolCalls } from './toolCallUtils';
import { ToolStepRow } from './ToolStepRow';

type ChatStepIndicatorProps = {
  parts: ChatUIMessage['parts'];
};

export const ChatStepIndicator = ({ parts }: ChatStepIndicatorProps) => {
  const intl = useIntl();
  const runs = getSubagentRuns(parts);
  const steps = extractToolCalls(parts.filter(isToolUIPart)).map(tc => {
    const run = runs.get(tc.toolCallId);
    return { tc, subagentCalls: run ? getSubagentToolCalls(parts, run) : [] };
  });

  if (steps.length === 0) return null;

  return (
    <CollapsibleSection
      data-cy="chat-tools-accordion"
      sx={{ mb: 1 }}
      label={intl.formatMessage(
        { id: 'features.chat.steps.toolsSummary' },
        { count: steps.length }
      )}
    >
      <Stack spacing={0.5} sx={{ mt: 0.5, pl: 2.5 }}>
        {steps.map(({ tc, subagentCalls }) => (
          <ToolStepRow
            key={tc.toolCallId}
            tc={tc}
            subagentCalls={subagentCalls}
          />
        ))}
      </Stack>
    </CollapsibleSection>
  );
};
